import type { DepartureDateFilterOptions } from '@/scopes/search/components/DepartureDateFilterLegacy/types'
import { useIntl } from '@/intl'
import { SegmentedControls } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { useDepartureDateFilter } from './hooks'

interface TabsProps extends React.HTMLAttributes<HTMLDivElement> {
  options: DepartureDateFilterOptions
}

const StyledTabWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`

function Tabs({ options, ...rest }: TabsProps) {
  const intl = useIntl()
  const { view, setView } = useDepartureDateFilter({ options })
  return (
    <StyledTabWrapper {...rest}>
      <SegmentedControls
        defaultActive={view}
        onActiveChange={({ value }) => setView(value as 'calendar' | 'month')}
        fixed
      >
        <SegmentedControls.Segment value="calendar">
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_calendar' })}
        </SegmentedControls.Segment>
        <SegmentedControls.Segment value="month">
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_month' })}
        </SegmentedControls.Segment>
      </SegmentedControls>
    </StyledTabWrapper>
  )
}

export default styled(Tabs)``
